import { useEffect, type JSX } from 'react';
import type { ChatSingleSelectContent } from '../../chatbot.types';
import { useChatSingleSelectViewModel } from './chat-single-select.viewmodel';

type Props = {
  messageId: string;
  content: ChatSingleSelectContent;
  onSelect: (messageId: string, optionId: string) => void;
};

export const ChatSingleSelect = ({ messageId, content, onSelect }: Props): JSX.Element => {
  const [state, viewModel] = useChatSingleSelectViewModel(messageId, content, onSelect);

  useEffect(() => {
    viewModel.setContent(content);
  }, [content, content.selectedId, viewModel]);

  return (
    <div>
      {state.prompt && <div className='chatbot-select-prompt'>{state.prompt}</div>}
      <div className='chatbot-options'>
        {state.options.map((option) => (
          <button
            key={option.id}
            disabled={state.isAnswered}
            className={viewModel.getOptionClassName(option.id)}
            onClick={() => viewModel.handleSelect(option.id)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
